"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAnchorAllowedChild = exports.isBlockElement = exports.isInlineElement = exports.checkIfIsItAString = void 0;
var BLOCK_ELEMENTS = ['address', 'article', 'aside', 'blockquote', 'canvas', 'dd', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hr', 'li', 'main', 'nav', 'noscript', 'ol', 'p', 'pre', 'section', 'table', 'tfoot', 'ul', 'video'];
var INLINE_ELEMENTS = ['a', 'abbr', 'acronym', 'b', 'bdo', 'big', 'br', 'button', 'cite', 'code', 'dfn', 'em', 'i', 'img', 'input', 'kbd', 'label', 'map', 'object', 'output', 'q', 'samp', 'script', 'select', 'small', 'span', 'strong', 'sub', 'sup', 'textarea', 'time', 'tt', 'var'];
var ANCHOR_ALLOWED_CHILDREN = ['b', 'i', 'span', 'strong', 'sub', 'sup', 'svg', 'SvgIcon', 'SvgIconLoader', 'SvgIconLabel', 'TextInfo', 'Notification', 'button'];

var checkIfIsItAString = function checkIfIsItAString(input) {
  var inputRes = '';

  if (input && typeof input === 'string') {
    inputRes = input;
  }

  return inputRes;
};

exports.checkIfIsItAString = checkIfIsItAString;

var isInlineElement = function isInlineElement(tagType) {
  var myTagType = checkIfIsItAString(tagType);
  var tagType2Cmp = myTagType.toLowerCase();
  var founded = INLINE_ELEMENTS.find(function (element) {
    var element2Cmp = element.toLowerCase();
    return element2Cmp === tagType2Cmp;
  });
  return !!founded;
};

exports.isInlineElement = isInlineElement;

var isBlockElement = function isBlockElement(tagType) {
  var myTagType = checkIfIsItAString(tagType);
  var tagType2Cmp = myTagType.toLowerCase();
  var founded = BLOCK_ELEMENTS.find(function (element) {
    var element2Cmp = element.toLowerCase();
    return element2Cmp === tagType2Cmp;
  });
  return !!founded;
};

exports.isBlockElement = isBlockElement;

var isAnchorAllowedChild = function isAnchorAllowedChild(tagType) {
  var myTagType = checkIfIsItAString(tagType);
  var tagType2Cmp = myTagType.toLowerCase();
  var founded = ANCHOR_ALLOWED_CHILDREN.find(function (element) {
    var element2Cmp = element.toLowerCase();
    return element2Cmp === tagType2Cmp;
  });
  return !!founded;
};

exports.isAnchorAllowedChild = isAnchorAllowedChild;

//# sourceMappingURL=index.js.map